module.exports = __webpack_public_path__ + "img/mastercard.be4f5552.svg";